import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import type { NavigationItemWithState } from '@/entities/navigation';

import { resolveIcon } from '@/entities/navigation';
import { NavItem } from '@/shared/ui';

import { useNavigationItem } from '../model/use-navigation-item';

interface NavigationItemProps {
  item: NavigationItemWithState;
  isCollapsed: boolean;
  onToggle: (code: string) => void;
  level?: number;
}

export const NavigationItem = ({ item, isCollapsed, onToggle, level = 0 }: NavigationItemProps) => {
  const { t } = useTranslation();
  const { hasSubItems, isActive, isExpanded, handleClick } = useNavigationItem(item);
  const Icon = resolveIcon(item.icon);

  const label = useMemo(
    () =>
      t(
        [
          `navigation.${item.code.toLowerCase()}_menu`,
          `navigation.${item.code.toLowerCase()}`,
          `sidebar.${item.code.toLowerCase()}`
        ],
        { defaultValue: item.label }
      ),
    [t, item.code, item.label]
  );

  return (
    <NavItem
      label={label}
      icon={Icon}
      badge={item.badge}
      isActive={isActive}
      isExpanded={isExpanded}
      isCollapsed={isCollapsed}
      hasSubItems={hasSubItems}
      onClick={() => handleClick(onToggle)}>
      {item.subItems?.map((subItem) => (
        <li key={subItem.code}>
          <NavigationItem
            item={subItem as NavigationItemWithState}
            isCollapsed={isCollapsed}
            onToggle={onToggle}
            level={level + 1}
          />
        </li>
      ))}
    </NavItem>
  );
};
